import * as React from 'react';
import { Link } from '../../../../../common/Link';
import { ErrorWrapper } from '../ErrorWrapper';
import { pointerIcon } from '../../icons';

interface IPriceEmptyProps {
  onLinkClick(): void;
}

export const PriceEmpty = ({ onLinkClick }: IPriceEmptyProps) => {
  return (
    <ErrorWrapper icon={pointerIcon}>
      Введите <Link onClick={onLinkClick}>цену</Link>, чтобы увидеть, на какой странице поиска будет объявление
    </ErrorWrapper>
  );
};
